// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    dd_env_name: 'unknown',
    production: false,
    base_url: 'https://dev.doctornow.io',
    socket_io_base_url: 'https://dev.doctornow.io:8086',
    app_base_url: 'https://api-dev.doctornow.io/api',
    url: 'https://api-dev.doctornow.io/api',
    url_documents: 'https://api-dev.doctornow.io/api/document',
    url_template: 'https://api-dev.doctornow.io/api/template',
    url_pcc: 'https://api-dev.doctornow.io/api/pcc',
    pcc_integration_base_url: 'https://connectdev.doctornow.io',
    url_patientroundingsheet: 'https://api-dev.doctornow.io/api/patientroundingsheet',
    url_patientintakeform: 'https://api-dev.doctornow.io/api/patientintakeform',
    rrgen: 'https://api-dev.doctornow.io/api/rrgen',
    SSO_LOGIN_URL: `https://dndev-elasticsearch.auth.us-east-1.amazoncognito.com/login?client_id=2bet1r62tnnt23mmebcmdnlmk0&response_type=code&scope=email+openid+phone+profile&redirect_uri=https://dev.doctornow.io/loginAuthRedirect`,
    PUSHER: {
        API_KEY: '8eb9cb12718a70494939',
        CLUSTER: 'mt1',
        FORCE_TLS: true
    }
};
